import React from 'react';

const OrderButton = ({ className, children }) => {
  const handleMenuShow = () => {
    const createMenu = document.createElement('iframe');
    createMenu.id = 'gfOrderFrm';
    createMenu.allowpaymentrequest = "true";
    createMenu.src = 'https://www.foodbooking.com/ordering/?restaurant_uid=c40c7189-7fc6-41af-835d-284faab90373&amp;return_url=http%3A%2F%2Flocalhost%3A5173%2F';
    createMenu.style = "z-index: 999998 !important; border: 0 !important; position:fixed !important; top:0 !important; left:0 !important; right:0 !important; bottom:0 !important; width:100% !important; height:100% !important; visibility: visible; opacity: 1;";
    createMenu.onmousewheel = "";
    document.body.appendChild(createMenu);
  };

  return (
    <button
      onClick={handleMenuShow}
      className={className}
    >
      {children || 'Order Now'}
    </button>
  );
};

export default OrderButton; 